<template>
    <div>
        <div class="pt-1 ft-overflow-auto pb-5 ft-bg-grey" v-if="$store.getters.getLspDemandList.length > 0">
            <demand-detail-card v-for="(demand, id) in $store.getters.getLspDemandList" 
            :key="id" 
            :data="demand" 
            btnText="Add Again" 
            subTitle="true"
            shareOption="true"
            _type="load"
            @share-action="openShareTool"/>
            <div v-if="$store.getters.getLspDemandList.length" v-observe-visibility="loadMore"></div>
            <div style="text-align: center" v-if="showPageLoader">
                <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
            </div>

        </div>
        <div v-if="$store.getters.getLspDemandList.length == 0 && !showPageLoader">
            <NoLoadsLsp route="lsp_app" type="my_loads"/>
        </div>
    </div>
</template>

<script>
import DemandDetailCard from '../components/DemandDetailCard.vue'
import NoLoadsLsp from '../components/NoLoadsLsp.vue';
import axios from "axios";
const API_BASE_URL = process.env.VUE_APP_API_GATEWAY_BASE_URL
import {identify} from '../utils/Mixpanel.js'
import config from '../config/config.js'

export default {
    components: {
        DemandDetailCard,
        NoLoadsLsp
    },
    data() {
        return {
            demandDetails: [],
            showPageLoader: false,
            pagination: {
                total: 0,
                pageSize: 3,
                currentPage: 0,
                searchAfter: null
            },
            pageSize: 3,
            currentPage: 0,
        }
    },
    methods: {
        loadMore(isVisible) {
            if (isVisible && (this.demandDetails.length < this.pagination.total)) {
                this.currentPage += 1;
                this.getDemadDetails()
            }
        },
        async getDemadDetails(isDefault = false) {
            this.showPageLoader = true
            try {
                const pageNo = isDefault ? 0 : this.currentPage;
                const {data} = await axios.get(`${API_BASE_URL}/demand/loads/${this.$route.params.id}?page_number=${pageNo}&page_size=${this.pageSize}`)
                this.pagination = data.pagination
                this.demandDetails = isDefault ? data.value : [...this.demandDetails, ...data.value]
                this.$store.commit('updateLspDemandList', this.demandDetails)
                identify(this.$route.params.id)

                this.$emit('mx-track', config.MIXPANEL_EVENTS.LSP_PAGE_LOAD)

            } catch (error) {
                console.log(error)
            }
            this.showPageLoader = false
        },
        openShareTool(demand) {
            const message = `Route: ${demand.origin} - ${demand.destination}\nID: ${demand.id}\nNo. of Trucks: ${demand.required_no_of_trucks}`
            const shareData = {
                title: `Demand Details`,
                text: `ID: ${demand.id}\nRoute: ${demand.origin} - ${demand.destination}\nNo. of Trucks: ${demand.required_no_of_trucks}`,
            }
            const mxData = {
                origin: demand.origin,
                destination: demand.destination,
                noOfVehicle: demand.required_no_of_trucks,
                rate: demand.rate
            }
            this.$emit('mx-track', config.MIXPANEL_EVENTS.LSP_CLICKED_SHARE, mxData)
            const _this = this
            this.$copyText(message).then(function () {
                _this.showToast('Load information is copied', 'info')
                if (navigator.share) {
                    navigator.share(shareData).then(() => {
                        _this.$emit('mx-track', config.MIXPANEL_EVENTS.LSP_LOAD_SHARED, mxData)
                    })
                } else {
                    alert("Browser doesn't support this feature!")
                }
            }, function () {
                alert('Can not copy')
            })
        },
        showToast(text, variant = null) {
            this.$bvToast.toast(text, {
                toaster: 'b-toaster-top-center',
                variant: variant,
                solid: true,
                noCloseButton: true
            })
        }
    },
    mounted() {
        this.getDemadDetails();
    }
}
</script>

